import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, takeUntil, tap } from 'rxjs/operators';

import { CustomResultOfPaginatedListOfGetSmsTemplatesWithPaginationDto } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AppDomService } from 'src/app/core/services/dom.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { GetSmsTemplateByIdDto } from './../../../core/api/models/get-sms-template-by-id-dto';
import { GetSmsTemplateGroupsDto } from './../../../core/api/models/get-sms-template-groups-dto';
import { GetSmsTemplatesWithPaginationDto } from './../../../core/api/models/get-sms-templates-with-pagination-dto';
import { PaginatedListOfGetSmsTemplatesWithPaginationDto } from './../../../core/api/models/paginated-list-of-get-sms-templates-with-pagination-dto';
import { SmsTemplatesService } from './../../../core/api/services/sms-templates.service';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { SmsTemplateFormComponent } from './sms-template-form/sms-template-form.component';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base';
import { ModalTitleComponent } from 'src/app/shared/global/modal-title/modal-title.component';

@Component({
    selector: 'app-sms-template',
    templateUrl: './sms-template.component.html',
    imports: [BaseIndexModule]
})
export class SmsTemplateComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName: string = PageNames.smsTemplate;
  protected currentService = inject(SmsTemplatesService);

  /** binding sms template service  to sms template component **/
  auditApiMethodName: string = this.currentService.smsTemplatesGetSmsTemplatesAudit.name;
  deleteApiMethodName: string = this.currentService.smsTemplatesDelete.name;
  createGetApiMethodName: string = this.currentService.smsTemplatesCreateGet.name;
  /** binding sms template service  to sms template component **/


  modelWithPagination$: Observable<PaginatedListOfGetSmsTemplatesWithPaginationDto>;
  items$: Observable<Array<GetSmsTemplatesWithPaginationDto>>;
  formPageConfig: FormPageConfig<GetSmsTemplateByIdDto> = {};

  @Input('isSmallSizePage') input_isSmallSizePage: boolean = false;
  @Input('group') input_group: GetSmsTemplateGroupsDto;
  @Input('showAuditBtn') input_showAuditBtn: boolean = true;
  @Input('isModalMode') input_isModalMode: boolean = false;

  @Output('selectedSmsTemplate') output_selectedSmsTemplate =
    new EventEmitter<number>();
  @Output('isVisibleAuditPage') output_isVisibleAuditPage =
    new EventEmitter<boolean>();

  //#endregion

  // constructor(protected currentService: SmsTemplatesService) {
  //   super();
  // }
  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showHelpBtn = false;

      if (this.input_isSmallSizePage) {
        this.paginationModel.pageSize = 5;
        this.input_group = null;
      }

      this.pageConfig.tableConfig.hasTableResponsive = true;
      this.pageConfig.tableConfig.hidePageSize = this.input_isSmallSizePage;
      this.pageConfig.showAuditBtn = this.input_showAuditBtn;

      if (this.input_isModalMode) {
        this.pageConfig.showHelpBtn = false;
        this.pageConfig.tableConfig.preloadingRowCount = 0;
      }

     // CreateGet => create/get api service binding has been change due to refactoring
     // this.setPageService(this.currentService, 'smsTemplatesCreateGet');

    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (changes['input_group'] && this.input_isSmallSizePage) {
        this.getTableData();
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  getTableData() {
    try {
      if (!this.input_group) return;
      super.getTableData();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.title, name: 'title', hasSearch: true },
      {
        title: this.localizer.group,
        name: 'SmsTemplateGroupTitle',
        hasSearch: !this.input_isSmallSizePage,
      },
      { title: this.localizer.text, name: 'body', hasSearch: true },
    ];
    try {
      //remove SmsTemplateGroup titel in small size page
      if (this.input_isSmallSizePage) this.tableColumns.splice(1, 1);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  onShowAuditPage() {
    if (this.input_isSmallSizePage) this.output_isVisibleAuditPage.emit(true);
    else this.pageConfig.isVisibleAuditPage = true;
  }

  //#region Api

  //Get All => pagination api binding has been changed due to refactoring
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfGetSmsTemplatesWithPaginationDto> {
    return this.currentService.smsTemplatesGetSmsTemplatesWithPagination({
      body: {
        ...this.getBaseModelWithPaginationParams(),
        smsTemplateGroupId: this.input_group.id,
      },
    });
  }

  //Delete => delete api binding has been changed due to refactoring
  // baseDeleteApi(id: number) {
  //   this.unSubs();

  //   this.pageConfig.loading = true;

  //   this.currentService
  //     .smsTemplatesDelete({ id: id })
  //     .pipe(this.basePipeOperators())
  //     .subscribe(this.baseObserver);
  // }

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .smsTemplatesUpdateGet({ smsTemplateId: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserverFormModal);
  }

  //#endregion

  //#region call actions

  openCreateFormModal() {
    try {
      this.unSubs();

      let data = {
        isEdit: false,
        title: `${this.formPageConfig?.vocabs}addTitle`,
        parentId: this.input_group?.id,
      };

      const modalResult = this.dialogService.openModal({
        component: SmsTemplateFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          finalize(() => (this.pageConfig.isVisibleForm = undefined)),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  openEditFormModal(id) {
    try {
      this.unSubs();

      let data = {
        title: `${this.formPageConfig?.vocabs}editTitle`,
        model: this.formPageConfig.editData,
        parentId: this.formPageConfig.parentId,
        id: this.formPageConfig.editId,
        isEdit: true,
      };

      const modalResult = this.dialogService.openModal({
        component: SmsTemplateFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  onDelete(model: GetSmsTemplatesWithPaginationDto) {
    try {
      let dialogResult = this.dialogService.confirmDialog({
        content: model.title,
        isConfirmDelete: true,
      });

      dialogResult
        .afterClosed()
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((result) => {
          if (result) {
            this.baseDeleteApi(model.id);
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  onSelect(body) {
    this.output_selectedSmsTemplate.emit(body);
  }

  //#endregion
}
